export default {
    '2b-diagram4': {
        'diagram-task': 'Identify the question that the main point raises, and the grouped ideas answer.',
        'checkboxes': {
            'title': 'Question:',
            'checkbox-1': 'How?',
            'checkbox-2': 'Why?',
            'checkbox-3': 'How know?'
        },
        'elements': {
            'one': 'Brands conveyed knowledge in an information-poor environment',
            'two': 'Served as a general indicator of quality',
            'three': 'Removed the risk from trying new products',
        }
    }
}



// WEBPACK FOOTER //
// ./client/app/components/diagrams/2/2b/diagram4/i18n/en.js